export default {
  title: 'Date et heure',
  buttons: {
    done: 'Terminé',
  },
};
